import { render, staticRenderFns } from "./HorseCharge.vue?vue&type=template&id=d398d1f6&"
import script from "./HorseCharge.vue?vue&type=script&lang=js&"
export * from "./HorseCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports